import { Box, useMediaQuery, useTheme } from "@mui/material";
import GlobalHeader from "./header";
import Sidebar from "./sidebar";
import { useState } from "react";

export default function MenuView({ children }) {
  const [openBar, setOpenBar] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const handleDrawerToggle = () => {
    setOpenBar(!openBar);
  };

  return (
    <>
      {isSmallScreen && <GlobalHeader />}
      <Box sx={{ display: "flex" }}>
        <Sidebar open={openBar} handleDrawerToggle={handleDrawerToggle} />
        <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
          {children}
        </Box>
      </Box>
    </>
  );
}
